import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { dispatchAppError } from './context/ConnectivityContext';
import { RootErrorBoundary } from './components/common/RootErrorBoundary';

// Global error handlers to catch and display errors
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
  // Vite's error overlay should handle this, but we log it as backup
  dispatchAppError();
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  // Vite's error overlay should handle this, but we log it as backup
  dispatchAppError();
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Wrap render in try-catch to catch any initialization errors
try {
  root.render(
    <React.StrictMode>
      <RootErrorBoundary>
        <App />
      </RootErrorBoundary>
    </React.StrictMode>
  );
} catch (error) {
  console.error('Error rendering app:', error);
  // Display error in the DOM if React fails to render
  const errorDiv = document.createElement('div');
  errorDiv.style.cssText =
    'padding: 20px; color: red; font-family: monospace; white-space: pre-wrap;';
  errorDiv.innerHTML = `
    <h1>Application Error</h1>
    <p><strong>Error:</strong> ${error instanceof Error ? error.message : String(error)}</p>
    <p><strong>Stack:</strong></p>
    <pre>${error instanceof Error ? error.stack : 'No stack trace available'}</pre>
    <p>Check the browser console for more details.</p>
  `;
  document.body.appendChild(errorDiv);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
